var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAccount(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 26",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.627 14.163c-.642-.498-1.257-1.179-1.503-1.755a6.914 6.914 0 0 1-.454-1.444c-.124-.646-.141-1.092-.136-2.457L6.535 8c0-2.565.177-4.07.88-5.192C8.268 1.448 9.65 1 11.535 1c1.787 0 3.158.474 4.011 1.797.737 1.145.99 2.875.99 5.203 0 2.298-.087 3.136-.423 4.294-.245.844-.655 1.403-1.317 1.9.046.018.1.035.161.05.214.056.464.106.871.177l.543.095c.22.038.403.073.581.109 1.285.26 2.184.605 2.877 1.241 1.31 1.203 2.035 2.839 2.324 4.694a11.404 11.404 0 0 1 .115 2.384c-.006.094-.006.094-.012.16l-.004.046c0 .008 0 .008-.002.014v.007s0 0 0 0v.001l-.1.889H1.096l-.062-.933c-.24-3.59.81-6.124 3.2-7.406.672-.36 1.368-.642 2.155-.892.294-.093.585-.178.953-.28-.074.021.648-.176.82-.225.087-.024.165-.047.238-.07a1.26 1.26 0 0 0 .227-.092z",
    strokeWidth: 2,
    fill: "none",
    fillRule: "evenodd"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccount);
export default __webpack_public_path__ + "static/media/Account.a6eb1da0d75b869c2edf06f0d75fc254.svg";
export { ForwardRef as ReactComponent };